<template>
	<div id="app">

        <div class="card border-primary" style="margin-bottom:20px;">
			<div class="card-header">
				<h5 style="margin-bottom:0px;">BetRadar NFL Scores</h5>
			</div>
			<div class="card-body">
				<div class="form-row">
					<div class="col">
						<div class="form-group">
							<label>Year</label>
							<select @change="selectYear" class="form-control">
								<option value="">-- Select --</option>
								<option value="2017">2017</option>
                                <option value="2018">2018</option>
                                <option value="2019">2019</option>
                                <option value="2020">2020</option>
                                <option value="2021" selected>2021</option>
							</select>
						</div>
					</div>
					<div class="col">
						<div class="form-group">
							<label>Season</label>
							<select @change="selectSeason" class="form-control">
								<option value="">-- Select --</option>
								<option value="PRE">PRE - Pre-season</option>
                                <option value="REG" selected>REG - Regular season</option>
                                <option value="PST">PST - Past season</option>
							</select>
						</div>
					</div>
                    <div class="col">
						<div class="form-group">
							<label>Week</label>
							<select @change="selectWeek" class="form-control">
								<option value="">-- Select --</option>
								<option v-for="n in 16" :value="n">{{n}}</option>
							</select>
						</div>
					</div>
				</div>
				
				<div>
					<p>These are the BetRadar endpoints used to build this page.</p>
					<table class="table" style="text-align:left;">
						<tr>
							<td>Standings</td>
							<td>
                                <a :href="getStandingsEndpoint(true)" target="_blank">{{ getStandingsEndpoint(true) }}</a>
                            </td>
						</tr>

                        <tr>
							<td>League Hierarchy</td>
							<td>
                                <a :href="getLeagueHierarchyEndpoint(true)" target="_blank">{{ getLeagueHierarchyEndpoint(true) }}</a>
                            </td>
						</tr>
					</table>
				</div>
				
			</div>
		</div>

        <div>
            <div id="accordion">
                <div class="card" v-if="standings">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#standings" aria-expanded="true" aria-controls="collapseOne">
							Standings
							</button>
						</h5>
					</div>

					<div id="standings" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
						
                            <div v-for="conference in standings.conferences">
                                <h3>Conference {{ conference.name }}</h3>

                                <div v-for="division in conference.divisions">

                                    <h4>Division {{division.name}} - id: {{division.id}}</h4>

                                    <table class="table">
                                        <tr>
                                            <th>name</th>
                                            <th>wins</th>
                                            <th>losses</th>
                                            <th>win_pct</th>
                                            <th>points_for</th>
                                            <th>points_against</th>
                                            <th>points_rank</th>
                                            <th>rank</th>
                                            <th>streak</th>
                                            <th>strength_of_schedule</th>
                                            <th>strength_of_victory</th>
                                            <th>record</th>
                                        </tr>
                                        <tr v-for="team in division.teams">
                                            <td>{{ team.market }} {{ team.name }}</td>
                                            <td>{{ team.wins }}</td>
                                            <td>{{ team.losses }}</td>
                                            <td>{{ team.win_pct }}</td>
                                            <td>{{ team.points_for }}</td>
                                            <td>{{ team.points_against }}</td>
                                            <td>{{ team.points_rank }}</td>
                                            <td>
                                                conference: {{ team.rank.conference }}<br>
                                                division: {{ team.rank.division }}<br>
                                            </td>
                                            <td>
                                                type: {{ team.streak.type }}<br>
                                                length: {{ team.streak.length }}<br>
                                            </td>
                                            <td>
                                                sos: {{ team.strength_of_schedule.sos }}<br>
                                                wins: {{ team.strength_of_schedule.wins }}<br>
                                                total: {{ team.strength_of_schedule.total }}<br>
                                            </td>
                                            <td>
                                                sov: {{ team.strength_of_victory.sov }}<br>
                                                wins: {{ team.strength_of_victory.wins }}<br>
                                                total: {{ team.strength_of_victory.total }}<br>
                                            </td>
                                            <td>
                                                <div v-for="record in team.records" style="border-bottom:1px solid #ccc;">
                                                    category: {{ record.record.category }}<br>
                                                    wins: {{ record.record.wins }}<br>
                                                    losses: {{ record.record.losses }}<br>
                                                    win_pct: {{ record.record.win_pct }}<br>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
						</div>
					</div>
				</div>

                <div class="card" v-if="league_hierarchy">
					<div class="card-header" id="headingOne">
						<h5 class="mb-0">
							<button class="btn btn-link" data-toggle="collapse" data-target="#league-hierarchy" aria-expanded="true" aria-controls="collapseOne">
							League Hierarchy
							</button>
						</h5>
					</div>

					<div id="league-hierarchy" class="collapse show" aria-labelledby="headingOne">
						<div class="card-body">
						
                            <div v-for="conference in league_hierarchy.conferences">
                                <h3>Conference {{ conference.name }}</h3>

                                <div v-for="division in conference.divisions">

                                    <h4>Division {{division.name}} - id: {{division.id}}</h4>
                                    
                                    <table class="table">
                                        <tr>
                                            <th>team</th>
                                            <th>venue</th>
                                        </tr>
                                        <tr v-for="team in division.teams">
                                            <td>{{ team.market }} {{ team.name }}</td>
                                            <td>
                                                <div v-if="team.venue">
                                                    id: {{ team.venue.id }}<br>
                                                    country: {{ team.venue.country }}<br>
                                                    name: {{ team.venue.name }}<br>
                                                    city: {{ team.venue.city }}<br>
                                                    state: {{ team.venue.state }}<br>
                                                    capacity: {{ team.venue.capacity }}<br>
                                                    surface: {{ team.venue.surface }}<br>
                                                    zip: {{ team.venue.zip }}<br>
                                                    address: {{ team.venue.address }}<br>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>

                                </div>
                            </div>
						</div>
					</div>
				</div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    name: 'app',
    components: {

	},
    created: function() {

        this.loadStandings();
        this.loadLeagueHierarchy();
    
    },
    data: function() {
        return {            
            apiKey: 'fz5pevvxgmnxt2nu4pnjptqg',
            year: 2021,
            season: "REG",
            week: 1,
            standings: [],
            league_hierarchy: []
        }
    }, 
    methods: {
        getStandingsEndpoint: function(showBetradarUrl = false) {
            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/seasons/${this.year}/standings.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        getLeagueHierarchyEndpoint: function(showBetradarUrl = false) { //League Hierarchy
            let url = `https://kaxmatrix.com/oddsapi/nfl/official/production/v6/en/league/hierarchy.json?api_key=${this.apiKey}`;

            if(showBetradarUrl) {
                url = url.replace('https://kaxmatrix.com/oddsapi', 'https://api.sportradar.us');
            }

            return url;
        },

        loadStandings: function() {

            // get full list of tournaments
            axios.get(this.getStandingsEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('standings', response.data);
                this.standings = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        loadLeagueHierarchy: function() {

            // get full list of tournaments
            axios.get(this.getLeagueHierarchyEndpoint(), 
                { crossdomain: true })
            .then((response) => {
                
                console.log('league_hierarchy', response.data);

                this.league_hierarchy = response.data;
                    
            
            }, (error) => {
                console.log(error)
            });
        },

        selectYear: function(event) {
			
			this.year = event.target.value;
            this.loadStandings();
            this.loadLeagueHierarchy();
        },

        selectSeason: function(event) {
			
			this.season = event.target.value;
            this.loadStandings();
            this.loadLeagueHierarchy();
        },

        selectWeek: function(event) {

            this.week = event.target.value;
            this.loadStandings();
            this.loadLeagueHierarchy();
        }
    },
}
</script>